module.exports = __webpack_public_path__ + "static/media/XL.95e864c4.jpg";